export {default} from './RegistrationWizard';
export * from './types';



// WEBPACK FOOTER //
// ./src/containers/RegistrationWizard/index.ts